import React from 'react'
import PropTypes from 'prop-types'
import DialogP153_2 from './DialogP153_2'
import { P109_0, P153_2, P154_0 } from 'rpqs/constants/RpqsConstant'
import DialogP109_0 from './DialogP109_0'
import DialogP154_0 from './DialogP154_0'

const FinancialDialog = ({
    open = false,
    setOpen = () => {},
    codeIndicator = '',
    dialogTitle = '',
}) => {
    return (
        <>
            {codeIndicator === P153_2.code &&
                <DialogP153_2
                    open={open}
                    setOpen={setOpen}
                    title={dialogTitle}
                />
            }
            {codeIndicator === P154_0.code &&
                <DialogP154_0
                    open={open}
                    setOpen={setOpen}
                    title={dialogTitle}
                />
            }
            {codeIndicator === P109_0.code &&
                <DialogP109_0
                    open={open}
                    setOpen={setOpen}
                    title={dialogTitle}
                />
            }
        </>
    )
}

FinancialDialog.propTypes = {
    setOpen: PropTypes.func,
    open: PropTypes.bool,
    codeIndicator: PropTypes.string,
    dialogTitle: PropTypes.string,
}

export default FinancialDialog